import { useContext, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { FlexGridWrapperContext } from 'core-components/sitebuilder/layout/context/FlexGridWrapperContext'
import { selectFlexSettings } from 'core-components/sitebuilder/store/selectors/selectFlexSettings'

export const useFlexSettings = () => {
  const { onFlexSettingsChanged } = useContext(FlexGridWrapperContext)
  const flexSettings = useSelector(selectFlexSettings)
  const isInitFlexSettingsRef = useRef<boolean>(false)

  useEffect(() => {
    if (!isInitFlexSettingsRef.current) {
      isInitFlexSettingsRef.current = true
    } else {
      onFlexSettingsChanged(flexSettings)
    }
  }, [onFlexSettingsChanged, flexSettings])

  return flexSettings
}
